/* eslint-disable jsx-a11y/anchor-is-valid */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-04-25 16:03:18
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { useEffect } from 'react';
import { SkeletonDisplayText, Tooltip } from '@shopify/polaris';
import { connect } from 'react-redux';
import Banner from 'src/components/views/common/banners/pfs-banner-custom';

import { withI18n } from '@shopify/react-i18n';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { getStoreDate, getStoreDateBefore } from 'src/helpers/analytics-helpers';
import { formatMoney } from 'src/helpers/money-format';
import * as AnalyticsActions from 'src/stores/actions/analytics-v2-actions';

const RenderPromoteBanner = props => {
  const {
    i18n,
    getTotalSearchRevenue,
    getConversionRate,
    getOrderCount,
    searchRevenueLoading,
    searchRevenueTotal,
    conversionRateLoading,
    conversionRatePercent,
    orderCountLoading,
    orderCountTotalSearch,
    moneyFormat
  } = props;

  useEffect(() => {
    const today = getStoreDate(new Date());
    const yesterday = getStoreDateBefore(today);
    const last30Days = getStoreDateBefore(today, 30);

    getTotalSearchRevenue(last30Days, yesterday, false, '', '');
    getConversionRate(last30Days, yesterday, false, '', '');
    getOrderCount(last30Days, yesterday, false, '', '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSeeMore = () => {
    history.push(routes.analytics.overviewSearch());
  };

  return (
    <div style={{ marginRight: '8px', marginTop: '8px' }}>
      <Banner
        name="aiSearchPromoteBanner"
        title={i18n.translate('AdminHTML.AdvanceSearch.PromoteBanner.title')}
        titleIcon="rocket"
        status="success"
        action={{
          content: i18n.translate('AdminHTML.AdvanceSearch.PromoteBanner.button'),
          onAction: onSeeMore
        }}
        allowDismiss={false}>
        <div>
          <div className="sub-content">
            <Tooltip
              content={i18n.translate('AdminHTML.AdvanceSearch.PromoteBanner.content01_Tooltip')}
              preferredPosition="above">
              <span className="sub-content-title">
                {i18n.translate('AdminHTML.AdvanceSearch.PromoteBanner.content01')}
              </span>
            </Tooltip>
            <div className="sub-content-value">
              {searchRevenueLoading ? (
                <SkeletonDisplayText size="small" />
              ) : (
                formatMoney(searchRevenueTotal, moneyFormat)
              )}
            </div>
          </div>
          <div className="sub-content">
            <Tooltip
              content={i18n.translate('AdminHTML.AdvanceSearch.PromoteBanner.content02_Tooltip')}
              preferredPosition="above">
              <span className="sub-content-title">
                {i18n.translate('AdminHTML.AdvanceSearch.PromoteBanner.content02')}
              </span>
            </Tooltip>
            <div className="sub-content-value">
              {conversionRateLoading ? <SkeletonDisplayText size="small" /> : conversionRatePercent}
            </div>
          </div>
          <div className="sub-content">
            <Tooltip
              content={i18n.translate('AdminHTML.AdvanceSearch.PromoteBanner.content03_Tooltip')}
              preferredPosition="above">
              <span className="sub-content-title">
                {i18n.translate('AdminHTML.AdvanceSearch.PromoteBanner.content03')}
              </span>
            </Tooltip>
            <div className="sub-content-value">
              {orderCountLoading ? <SkeletonDisplayText size="small" /> : orderCountTotalSearch}
            </div>
          </div>
        </div>
      </Banner>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    // Total search revenue
    searchRevenueLoading: _.get(state.analyticsV2, 'searchRevenueLoading', false),
    searchRevenueTotal: _.get(state.analyticsV2, 'searchRevenueTotal', 0),

    // Conversion rate
    conversionRateLoading: _.get(state.analyticsV2, 'conversionRateLoading', false),
    conversionRatePercent: _.get(state.analyticsV2, 'conversionRatePercent', ''),

    // Order count
    orderCountTotalSearch: _.get(state.analyticsV2, 'orderCountTotal.search', 0),
    orderCountLoading: _.get(state.analyticsV2, 'orderCountLoading', false),

    moneyFormat: _.get(state.oauth, 'tenantApp.externalInfo.money_format', '')
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getTotalSearchRevenue: (from, to, compare, queryExecutionId, comparedExecutionId) =>
    dispatch(
      AnalyticsActions.getTotalSearchRevenue(
        from,
        to,
        compare,
        queryExecutionId,
        comparedExecutionId,
        ownProps.i18n
      )
    ),
  getConversionRate: (from, to, compare, queryExecutionId, comparedExecutionId) =>
    dispatch(
      AnalyticsActions.getConversionRate(
        from,
        to,
        compare,
        queryExecutionId,
        comparedExecutionId,
        ownProps.i18n
      )
    ),
  getOrderCount: (from, to, compare, queryExecutionId, comparedQueryExecutionId) =>
    dispatch(
      AnalyticsActions.getOrderCount(
        from,
        to,
        compare,
        queryExecutionId,
        comparedQueryExecutionId,
        ownProps.i18n
      )
    )
});
export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(RenderPromoteBanner));
